// extracted by mini-css-extract-plugin
export default {"form":"AddDataSourceForm_form__on49l","form-container":"AddDataSourceForm_form-container__LFITy"};